import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Safari = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.094 22.416c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m5.77-15.318c.22-.301-.154-.677-.456-.458l-6.814 4.276a.33.33 0 0 0-.112.144l-4.159 6.674c-.22.301.154.677.456.458l6.815-4.276a.33.33 0 0 0 .112-.144z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.094 22.416c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10m5.77-15.318c.22-.301-.154-.677-.456-.458l-6.814 4.276a.33.33 0 0 0-.112.144l-4.159 6.674c-.22.301.154.677.456.458l6.815-4.276a.33.33 0 0 0 .112-.144z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
